import { Injectable, inject } from '@angular/core';
import {PaginatorNew, TableOrder} from '../../global';
import { CompanyUserService } from '../services/company-user.service';
import {CompanyUserUpdate} from '../entities/users.entity';
import {Store} from '@ngrx/store';
import {userActions, userSelectors} from '../+states';
import {filter, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CompanyUserSandbox {
  private readonly companyService = inject(CompanyUserService);
  private readonly store = inject(Store);

  getUsers = (
    page: PaginatorNew,
    order: TableOrder,
    search: string = null,
    isActive: boolean = true,
    shortInfo: boolean = false
  ) =>
    this.companyService.getUsers(
      page,
      order,
      search,
      isActive ? 'active' : 'inactive',
      shortInfo
    );

  updateUser = (user: CompanyUserUpdate) =>
    this.companyService.updateUser(user);

  createUser = (user: CompanyUserUpdate) =>
    this.companyService.createUser(user);

  updatePassword = (id: number, password) =>
    this.companyService.updateUserPassword(id, password);

  updateUserStatus = (ids: Array<number>, status: string) =>
    this.companyService.updateUserStatus(ids, status);

  getUser = (id: number) => this.companyService.getUser(id);

  getUserStatistics = () =>
    this.companyService.getUserStatistics();

  public refreshUserStatistics(): void {
    this.store.dispatch(userActions.clearUserStatistics());
  }

  public readonly userStatistics$ =
    this.store.select(userSelectors.getUserStatistics()).pipe(
      filter(statistics => {
        if(!statistics?.current && !statistics?.free){
          this.refreshUserStatistics();
        }
        return true;
      }),
      map(statistics => statistics)
    );
}
